export enum MODAL_PARAMS_KEYS {
  CONNECT_APP = 'connect-app',
  SETTINGS = 'settings',
  EXPLANATION = 'explanation',
  INITIAL = 'initial',
  IMPORT_KEYS = 'import-keys',
  LOGIN = 'login',
  SIGN_UP = 'sign-up',
  CONFIRM_CONNECT = 'confirm-connect',
  CONFIRM_EVENT = 'confirm-event',
  ACTIVITY = 'activity',
  APP_DETAILS = 'app-details',
  EDIT_NAME = 'edit-name',
  SET_PASSWORD = 'set-password',
  ADD_PERMISSION = 'add-permission',
}

export enum EXPLANATION_MODAL_KEYS {
  BUNKER = 'bunker',
  NPUB = 'npub',
  LOGIN = 'login',
  HOW = 'how',
}
